import React from 'react';
import { RiPlayFill, RiPauseFill } from 'react-icons/ri';

export default function VolumeToggle({ playing, onTogglePlay }) {
  return (
    <div className={`audio-control ${playing ? 'audio-control--playing' : ''}`}>
      <button
        className="audio-control__btn"
        onClick={onTogglePlay}
        aria-label={playing ? 'Pause music' : 'Play music'}
      >
        <span className={`audio-control__icon ${!playing ? 'audio-control__icon--active' : ''}`}>
          <RiPlayFill />
        </span>
        <span className={`audio-control__icon ${playing ? 'audio-control__icon--active' : ''}`}>
          <RiPauseFill />
        </span>
        {playing && (
          <span className="audio-control__bars">
            <span /><span /><span />
          </span>
        )}
      </button>
    </div>
  );
}
